<template>
  <v-container>
    <h1 class="text-center">Giveaway</h1>
    <v-form ref="form" v-model="formValid">
      <div v-if="giveawayLoaded && !giveawayFound">
        Nice try, goodbye!
      </div>
      <div v-else-if="giveawayLoaded && giveawayFound">
        <h2 class="text-center">{{ giveaway.title }}</h2>
        <p class="text-center">{{ giveaway.description }}</p>
        <p>User: {{ $store.state.username }}</p>
        <p>{{ settings.name }}: {{ $store.state.loyaltypoints }}</p>
        <v-btn
          tile
          color="#9147ff"
          class="text--white"
          :href="loginUrl"
          v-if="!$store.state.logged_in"
        >
          <v-icon left>mdi-twitch</v-icon>
          Login mit Twitch
        </v-btn>

        <!-- Desktop: Tabelle -->
        <template v-if="!$vuetify.breakpoint.smAndDown">
          <v-row class="giveaway_header">
            <v-col cols="3">Teilnehmer</v-col>
            <v-col cols="3">Gekaufte Tickets</v-col>
            <v-col cols="3">Abgelaufene Zeit</v-col>
            <v-col cols="3">Kosten pro Ticket</v-col>
          </v-row>
          <v-row class="giveaway_body">
            <v-col cols="3">{{ giveaway.unique_entries }}</v-col>
            <v-col cols="3">{{ giveaway.total_entries }}</v-col>
            <v-col cols="3">{{ timer }}</v-col>
            <v-col cols="3">{{ giveaway.cost_per_ticket }} {{ settings.name }}</v-col>
          </v-row>
        </template>

        <!-- Mobile: Stats-Card 2×2 -->
        <v-card v-else outlined class="my-3">
          <v-card-text class="pa-0">
            <v-row dense no-gutters>
              <v-col cols="6" class="stat-cell">
                <div class="stat-label">Teilnehmer</div>
                <div class="stat-value">{{ giveaway.unique_entries }}</div>
              </v-col>
              <v-col cols="6" class="stat-cell stat-cell--bordered-left">
                <div class="stat-label">Gekaufte Tickets</div>
                <div class="stat-value">{{ giveaway.total_entries }}</div>
              </v-col>
              <v-col cols="6" class="stat-cell stat-cell--bordered-top">
                <div class="stat-label">Abgelaufene Zeit</div>
                <div class="stat-value">{{ timer }}</div>
              </v-col>
              <v-col cols="6" class="stat-cell stat-cell--bordered-top stat-cell--bordered-left">
                <div class="stat-label">Kosten/Ticket</div>
                <div class="stat-value">{{ giveaway.cost_per_ticket }} {{ settings.name }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Ticket-Editor -->
        <v-row class="text-center mt-4">
          <v-col cols="12" sm="4" offset-sm="4">
            <v-text-field
              v-model="ticket_buy"
              label="Ticket kaufen"
              type="number"
              min="1"
              :rules="rulesWith0"
              :max="Math.min(
                this.giveaway.ticker_per_user - this.$store.state.ticket_from_user,
                Math.floor(this.$store.state.loyaltypoints / this.giveaway.cost_per_ticket)
              )"
              :outlined="$vuetify.breakpoint.smAndDown"
              :error="ticketBuyError !== null"
              :error-messages="ticketBuyError"
              @focus="ticketBuyError = null"
              :hint="'Du nimmst bereits mit: ' + $store.state.ticket_from_user + ' Tickets teil! '"
              persistent-hint
            ></v-text-field>
            <v-btn
              tile
              color="#9147ff"
              class="text--white mt-2"
              :block="$vuetify.breakpoint.smAndDown"
              :href="loginUrl"
              v-if="!$store.state.logged_in"
            >
              <v-icon left>mdi-twitch</v-icon>
              Login mit Twitch
            </v-btn>
            <v-btn
              tile
              color="#9147ff"
              class="text--white mt-2"
              :block="$vuetify.breakpoint.smAndDown"
              @click="ticketbuy()"
              v-if="$store.state.logged_in"
            >
              Ticket kaufen
            </v-btn>
          </v-col>
        </v-row>

        <v-snackbar v-model="ErrorFlag" timeout="3000" color="red">
          Überprüfe die roten Felder!
          <template v-slot:actions>
            <v-btn color="pink" variant="text" @click="ErrorFlag = false">Close</v-btn>
          </template>
        </v-snackbar>

        <LoyaltyCard :settings="settings" />
      </div>
      <div v-else>
        Loading....
      </div>
    </v-form>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';
import LoyaltyCard from '@/components/LoyaltyCard.vue';

export default {
  name: 'GiveawayView',

  data: () => ({
    sendData: {},
    ticket_buy: '',
    giveawayLoaded: false,
    giveawayFound: false,
    giveaway: {},
    settings: {},
    intervalId: null,
    timer: null,
    ticketBuyError: null,
    formValid: false,
    rulesPositiveNumber: [
      (v) => !!v || 'Feld darf nicht leer sein',
      (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
      (v) => parseFloat(v) > 0 || 'Zahl muss positiv sein',
      (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
    ],
    rulesWith0: [
      (v) => (v !== null && (v) !== undefined) || 'Feld darf nicht leer sein',
      (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
      (v) => parseFloat(v) >= 0 || 'Zahl muss positiv sein',
      (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
    ],
    ErrorFlag: false,
  }),
  components: {
    LoyaltyCard,
  },
  mounted() {
    this.intervalId = window.setInterval(this.updateTimer, 1000);
    this.loadInstance(this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    this.loadInstance(to.params.id);
    next();
  },
  computed: {},
  destroyed() {
    clearInterval(this.intervalId);
  },
  methods: {
    loadInstance(id) {
      // Reset first so the previous instance's giveaway never flashes while the new one loads.
      this.giveawayLoaded = false;
      this.giveawayFound = false;
      this.giveaway = {};
      this.settings = {};
      this.sendData = { id, username: this.$store.state.username };
      BackendService.loadSingleGiveaway(this.sendData).then((data) => {
        if (data.data.giveaway.length > 0) {
          this.giveawayFound = true;
          this.giveaway = { ...data.data.giveaway[0] };
          this.settings = { ...data.data.settings };
          this.$store.commit('set_ticket', data.data.giveaway[0].ticket_from_user);
        }
        this.giveawayLoaded = true;
      }).finally(() => {
        this.$store.dispatch('refreshStatus');
      });
    },
    ticketbuy() {
      const ticketBuy = parseInt(this.ticket_buy, 10);
      if (Number.isNaN(ticketBuy)) {
        this.ticketBuyError = 'Bitte gib eine Zahl ein';
      } else if (ticketBuy < 1) {
        this.ticketBuyError = 'Du must schon mindestens ein Ticket kaufen...';
      } else if (this.giveaway.cost_per_ticket * ticketBuy > this.$store.state.loyaltypoints) {
        this.ticketBuyError = `Du kannst dir maximal ${Math.floor(this.$store.state.loyaltypoints / this.giveaway.cost_per_ticket)} Tickets leisten`;
      } else if (this.giveaway.ticker_per_user < ticketBuy + this.$store.state.ticket_from_user) {
        this.ticketBuyError = `Du kannst maximal ${this.giveaway.ticker_per_user} Tickets hierfür haben - da du schon ${this.$store.state.ticket_from_user} hast, kannst dir maximal ${this.giveaway.ticker_per_user - this.$store.state.ticket_from_user} Tickets kaufen`;
      } else {
        BackendService.ticketbuy({ tickets: ticketBuy, giveaway: this.giveaway.id })
          .then((data) => {
            this.ticket_buy = null;
            if (data.data.points !== undefined) {
              this.$store.commit('set_loyaltypoints', data.data.points);
            }
            if (data.data.tickets !== undefined) {
              this.$store.commit('set_ticket', data.data.tickets);
            }
          });
      }
    },
    updateTimer() {
      if (this.giveawayFound) {
        let out = [];
        let seconds = Math.floor(new Date().getTime() / 1000) - this.giveaway.started;
        out.push(Math.floor(seconds / 86400));
        seconds %= 86400;
        out.push(Math.floor(seconds / 3600));
        seconds %= 3600;
        out.push(Math.floor(seconds / 60));
        seconds %= 60;

        while (out.length > 0 && out[0] === 0) {
          out.shift();
        }
        out.push(seconds);

        out = out.map((value, index) => (index === 0 ? value : (`${value}`).padStart(2, '0')));

        this.timer = out.join(':');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.giveaway {
  &_header {
    background-color: darkblue;
    color: white;
    text-align: center;
    width: 50vw;
    margin: 10px auto 0 auto;
  }

  &_body {
    text-align: center;
    width: 50vw;
    margin: 10px auto 0 auto;
  }
}

.stat-cell {
  text-align: center;
  padding: 12px 8px;

  &--bordered-left {
    border-left: 1px solid rgba(0, 0, 0, 0.12);
  }

  &--bordered-top {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
}

.stat-label {
  font-size: 0.7rem;
  background-color: darkblue;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
  padding: 2px 4px;
}

.stat-value {
  font-size: 1.1rem;
  font-weight: 600;
}
</style>
